/* eslint-disable */

import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs'
import Summary from './Summary'
import Assets from './Assets'
import Liabilities from './Liabilities'






const TABS = [
    {
        label: 'Summary',
        value: 'summary',
    },
    {
        label: 'Asset',
        value: 'asset',
    },
    {
        label: 'Liabilities',
        value: 'liabilities',
    },

]

const FamilyDashboard = () => {
    return (
        <div className='max-w-[1128px] mx-auto bg-gray-50 lg:bg-white min-h-screen'>


            <Tabs defaultValue='summary' className='w-full mb-2'>
                <TabsList
                    className='w-full justify-start rounded-none border-b bg-transparent p-0 overflow-x-auto flex-nowrap'
                >
                    {TABS.map((tab) => (
                        <TabsTrigger key={tab.value} value={tab.value} className="mb-[-8px]">
                            {tab.label}
                        </TabsTrigger>
                    ))}
                </TabsList>
                <TabsContent value='summary'>
                    <Summary />
                </TabsContent>
                <TabsContent value='asset'> <Assets /> </TabsContent>
                <TabsContent value='liabilities'> <Liabilities /> </TabsContent>
            </Tabs>


        </div>
    )
}

export default FamilyDashboard